import { MergedIntlProvider } from '@olxpwa-lib/i18n/client';
import { useMemo } from 'react';
import { useE2EMode } from '~features/e2e-mode';
import { makeMessagesLoader } from './messages-loader';

type Props = {
  children: React.ReactNode;
};

export const IntlProvider: React.FC<Props> = ({ children }) => {
  const e2eMode = useE2EMode();
  const messagesLoader = useMemo(() => makeMessagesLoader(e2eMode), [e2eMode]);

  return (
    <MergedIntlProvider loader={messagesLoader} context="">
      {children}
    </MergedIntlProvider>
  );
};
